"use strict";
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getToggleCardSlots = exports.default = exports.ToggleCard = void 0;
var _icons = require("@ori-ui/icons");
var _base = require("@ori-ui/mui-bundle/base");
var _material = require("@ori-ui/mui-bundle/material");
var _clsx = _interopRequireDefault(require("clsx"));
var _react = require("react");
var _toggleCardClasses = _interopRequireWildcard(require("./toggleCardClasses"));
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function _interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != (typeof e === "undefined" ? "undefined" : _type_of(e)) && "function" != typeof e) return {
        default: e
    };
    var t = _getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
var getToggleCardSlots = function(ownerState) {
    var disabled = ownerState.disabled;
    return {
        root: [
            'root',
            disabled && 'disabled'
        ],
        icon: [
            'icon'
        ],
        indicator: [
            'indicator'
        ],
        input: [
            'input'
        ]
    };
};
exports.getToggleCardSlots = getToggleCardSlots;
var useUtilityClasses = function(ownerState) {
    var classes = ownerState.classes;
    var slots = getToggleCardSlots(ownerState);
    var composedClasses = (0, _base.unstable_composeClasses)(slots, _toggleCardClasses.getToggleCardUtilityClass, classes);
    return _object_spread({}, classes, composedClasses);
};
var ToggleCardRoot = (0, _material.styled)('label', {
    name: 'MuiOriToggleCard',
    slot: 'Root',
    overridesResolver: function(param, styles) {
        var ownerState = param.ownerState;
        return [
            styles.root
        ];
    }
})(function(param) {
    var ownerState = param.ownerState, theme = param.theme;
    return _object_spread(_define_property({
        position: 'relative',
        display: 'block',
        borderRadius: theme.shape.largeComponentRadius,
        padding: theme.spacing(4, 3),
        cursor: 'pointer',
        userSelect: 'none',
        boxShadow: theme.shadows[0],
        border: "1px solid ".concat(theme.palette.grey[500]),
        backgroundColor: theme.palette.background.paper,
        color: theme.palette.text.primary,
        transition: theme.transitions.create('box-shadow')
    }, "&.".concat(_toggleCardClasses.default.disabled), {
        borderColor: theme.palette.grey[300],
        color: theme.palette.grey.A700,
        background: theme.palette.grey[100],
        cursor: 'unset'
    }), ownerState.checked && {
        boxShadow: theme.shadows[3],
        border: "1px solid ".concat(theme.palette.background.paper)
    });
});
var Input = (0, _material.styled)('input', {
    name: 'MuiOriToggleCard',
    slot: 'Input',
    overridesResolver: function(_, styles) {
        return [
            styles.input
        ];
    }
})({
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    height: 1,
    overflow: 'hidden',
    position: 'absolute',
    whiteSpace: 'nowrap',
    width: 1
});
var Indicator = (0, _material.styled)('div', {
    name: 'MuiOriToggleCard',
    slot: 'Indicator',
    overridesResolver: function(_, styles) {
        return [
            styles.indicator
        ];
    }
})(function(param) {
    var theme = param.theme, ownerState = param.ownerState;
    return _object_spread({
        position: 'absolute',
        opacity: 0,
        top: -1,
        left: -1,
        width: 50,
        height: 50,
        overflow: 'hidden',
        borderTopLeftRadius: theme.shape.largeComponentRadius,
        transition: theme.transitions.create('opacity'),
        '&:before': _object_spread({
            position: 'absolute',
            top: 0,
            left: 0,
            content: '""',
            transform: 'translate(-50%, -50%) rotate(45deg)',
            width: 50,
            height: 50,
            zIndex: 0,
            background: theme.palette.primary.main
        }, ownerState.disabled && {
            background: theme.palette.grey[400]
        })
    }, ownerState.checked && {
        opacity: 1
    });
});
var StyledIcon = (0, _material.styled)(_material.Icon, {
    name: 'MuiOriToggleCard',
    slot: 'Icon',
    overridesResolver: function(_, styles) {
        return [
            styles.icon
        ];
    }
})(function(param) {
    var theme = param.theme, ownerState = param.ownerState;
    return {
        color: theme.palette.text.primary,
        position: 'relative',
        margin: 1
    };
});
function areEqualValues(a, b) {
    if ((typeof b === "undefined" ? "undefined" : _type_of(b)) === 'object' && b !== null) {
        return a === b;
    }
    // The value could be a number, the DOM will stringify it anyway.
    return String(a) === String(b);
}
var ToggleCard = exports.ToggleCard = /*#__PURE__*/ (0, _react.forwardRef)(function(inProps, ref) {
    var props = (0, _material.useThemeProps)({
        props: inProps,
        name: 'MuiOriToggleCard'
    });
    var checkedProp = props.checked, defaultChecked = props.defaultChecked, disabledProp = props.disabled, onBlur = props.onBlur, onChangeProp = props.onChange, onFocus = props.onFocus, readOnlyProp = props.readOnly, required = props.required, inputProps = props.inputProps, className = props.className, componentProp = props.component, children = props.children, _props_Icon = props.Icon, Icon = _props_Icon === void 0 ? _icons.CheckHeavy : _props_Icon, IconProps = props.IconProps, id = props.id, nameProp = props.name, onFocusVisible = props.onFocusVisible, value = props.value, tmp = props.type, typeProp = tmp === void 0 ? 'checkbox' : tmp, sx = props.sx, otherProps = _object_without_properties(props, [
        "checked",
        "defaultChecked",
        "disabled",
        "onBlur",
        "onChange",
        "onFocus",
        "readOnly",
        "required",
        "inputProps",
        "className",
        "component",
        "children",
        "Icon",
        "IconProps",
        "id",
        "name",
        "onFocusVisible",
        "value",
        "type",
        "sx"
    ]);
    var radioGroup = (0, _material.useRadioGroup)();
    // @ts-expect-error -- Incorrect types
    var onChange = (0, _material.createChainedFunction)(onChangeProp, radioGroup === null || radioGroup === void 0 ? void 0 : radioGroup.onChange);
    var type = typeProp;
    var component = componentProp !== null && componentProp !== void 0 ? componentProp : 'label';
    var componentProps = {
        htmlFor: id
    };
    var internalChecked = checkedProp;
    var name = nameProp;
    if (radioGroup) {
        type = 'radio';
        componentProps = {};
        component = componentProp !== null && componentProp !== void 0 ? componentProp : _material.Paper;
        if (typeof internalChecked === 'undefined') {
            internalChecked = areEqualValues(radioGroup.value, value);
        }
        if (typeof name === 'undefined') {
            name = radioGroup.name;
        }
    }
    var useSwitchProps = {
        checked: internalChecked,
        defaultChecked: defaultChecked,
        disabled: disabledProp,
        onBlur: onBlur,
        onChange: onChange,
        onFocus: onFocus,
        readOnly: readOnlyProp,
        onFocusVisible: onFocusVisible,
        required: required
    };
    var _ref = (0, _base.useSwitch)(useSwitchProps), getInputProps = _ref.getInputProps, checked = _ref.checked, disabled = _ref.disabled, focusVisible = _ref.focusVisible, readOnly = _ref.readOnly;
    var ownerState = _object_spread_props(_object_spread({}, props), {
        checked: checked,
        disabled: disabled,
        focusVisible: focusVisible,
        readOnly: readOnly
    });
    var classes = useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(ToggleCardRoot, _object_spread_props(_object_spread({
        ref: ref,
        ownerState: ownerState,
        className: (0, _clsx.default)(classes.root, className),
        as: component,
        sx: sx
    }, componentProps, otherProps), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(Indicator, {
                ownerState: ownerState,
                className: classes.indicator,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledIcon, _object_spread({
                    ownerState: ownerState,
                    className: classes.icon,
                    as: Icon,
                    fontSize: "small"
                }, IconProps))
            }),
            children,
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(Input, _object_spread_props(_object_spread({
                id: id
            }, getInputProps(_object_spread({
                name: name,
                type: type,
                value: value
            }, inputProps))), {
                ownerState: ownerState,
                className: classes.input,
                "data-checked": internalChecked
            }))
        ]
    }));
});
var _default = exports.default = ToggleCard; //# sourceMappingURL=ToggleCard.js.map
